import { Component, OnInit } from '@angular/core';
import { User } from '../../../model/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../services/user/user.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-siteuseradd',
  templateUrl: './siteuseradd.component.html',
  styleUrls: ['./siteuseradd.component.css']
})
export class SiteuseraddComponent implements OnInit {

  user: User;
  isLoading: boolean = false;
  isRegisterSuccess: boolean = false;
  isRegisterFailure: boolean = false;

  isEcodeFailure: boolean = false;
  errorMessages: any = [];
  isPasswordError: boolean = false;

  selecteduserstatus: string;
  isEmailError : boolean = false;

  userstatusoptions = [
    { name: "Inactive", value: "inactive" },
    { name: "Active", value: "active" }
  ]

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.user = new User;
    // this.user = {
    //   Email: '',
    //   Password: '',
    //   ConfirmPassword: '',
    //   PhoneNumber: '',
    //   Address: '',
    //   userType: '',
    //   FullName: '',
    //   VendorCode: '',
    //   type: '',
    //   IsActive: '',
    //   CreatedBy: '',
    //   CreatedOn: '',
    //   UpdatedBy: '',
    //   UpdatedOn: '',
    //   RegisterCode: '',
    //   Error: ''
    // }
  }

  OnSubmit(form: NgForm) {
    this.errorMessages = [];
    this.isLoading = true;
    this.isRegisterFailure = false;
    this.isRegisterSuccess = false;
    this.isEcodeFailure = false;
    this.isPasswordError = false;
    this.isEmailError = false;

    if (!isNullOrUndefined(form.value.userType)) {
      if (form.value.userType == 1) {
        form.value.type = "Admin";
        //form.value.registerCode = "mpadmin";
      }
      else if (form.value.userType == 2) {
        form.value.type = "Employee";
        //form.value.registerCode = "mpemployee";
      }
      else if (form.value.userType == 3) {
        form.value.type = "HR";
        //form.value.registerCode = "mphr";
      }
      else { }
    }

    var emailregex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    if (!form.value.email.match(emailregex)) {
      this.isEmailError = true;
      this.isLoading = false;
      return false;
    }

    if (form.value.password != form.value.confirmPassword || form.value.password.length < 6) {
      this.isLoading = false;
      this.isPasswordError = true;
    }
    else {

      this.userService.registerUser(form.value)
        .subscribe((data: any) => {

          if (data == false) {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }
          else if (data.error == "ecodeerror" && data.succeeded == false) {
            this.isLoading = false;
            this.isEcodeFailure = true;
          }
          else if (data.errors.length > 0 && data.succeeded == false) {
            this.errorMessages = data.errors;
            this.isLoading = false;
          }
          else if (data.errors.length == 0 && data.succeeded == true) {
            this.resetForm(form);
            this.isLoading = false;
            this.isRegisterSuccess = true;
          }
          else {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }

          // if(data == true)
          // {
          //   this.resetForm(form);
          //   this.isLoading = false;
          //   this.isRegisterSuccess = true;
          // }
          // else
          // {
          //   this.isLoading = false;
          //   this.isRegisterFailure = true;
          // }
        });

    }

  }



}
